import CloseIcon from '@mui/icons-material/Close';
import ToastMessage from '../utils/mui/righttoptoast';
import api from '../api/api';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../reduxtoolkit/toastslice';
import { getPracticeId } from '../config/practice';

const DeleteEntryModal = ({ setDeleteModal, selectedItem, fetchInventory, setLoading }) => {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const dispatch=useDispatch()

  const handleCloseToast = () => {
    setToast((prev) => ({ ...prev, open: false }));
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`/v1/${getPracticeId()}/inventory/${selectedItem.id}`);
      // setToast({ open: true, message: 'Item deleted successfully', severity: 'success' });
        dispatch(
                showToast({
                  message: 'Item deleted successfully',
                  severity: "success",
                }),
              );
      fetchInventory();


    setDeleteModal(false)
    } catch (error) {
      
      console.error(error);
      setToast({ open: true, message: 'Failed to delete item', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-full max-w-sm bg-white rounded-[8.75px] border p-6">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-600 hover:text-black"
          onClick={() => setDeleteModal(false)}
        >
          <CloseIcon />
        </button>

        <h2 className="text-sm font-bold mb-4 text-start">Delete Confirmation</h2>
        <p className="text-sm text-[#0A0A0A] mb-6 text-start">
          Are you sure you want to delete <strong>{selectedItem?.item_name}</strong>?
        </p>

        {/* Action Buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={() => setDeleteModal(false)}
            className="border px-4 py-1 rounded text-sm text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="bg-black text-white px-4 py-1 rounded text-sm"
          >
            Delete
          </button>
        </div>

        {/* Toast */}
        <ToastMessage
          message={toast.message}
          severity={toast.severity}
          open={toast.open}
          handleClose={handleCloseToast}
        />
      </div>
    </div>
  );
};

export default DeleteEntryModal;
